// prettier-ignore

// *****
// Add a key for each translated string.
// Use dot notation to structure the strings better.
// Start the key with the page or component name.
// Please use logical and understandable keys.
// Please check to see if a translattion is already done before adding a new one.
// *****

export default {
    // Globals
    'globals.locale': 'nl-be',
    'globals.signIn': 'Aanmelden',
    'globals.logIn': 'Inloggen',
    'globals.signUp': 'Registreren',
    'globals.signOut': 'Afmelden',
    'globals.logOut': 'Uitloggen',
    'globals.submit': 'Verzenden',
    'globals.submitting': 'Verzenden...',
    'globals.yourEmail': 'Uw e-mailadres',
    'globals.yourPassword': 'Uw wachtwoord',
    'globals.courseOverview': 'Cursusoverzicht',
    'globals.forgotPassword': 'Wachtwoord vergeten?',
    'globals.invalidCredentials': 'Ongeldige gegevens',
    'globals.section': 'Rubriek',
    'globals.exercises': 'Oefeningen',
    'globals.chapter': 'Hoofdstuk',
    'globals.introToAI': 'Inleiding in AI',
    'globals.buildingAI': 'AI opbouwen',
    'globals.acceptPolicy': 'Accept policy',
    // section
    'section.footerEndOfTheChapter': 'Dit is het einde van hoofdstuk {chapter}!',
    'section.footerEndOfTheCourseTitle': 'Dit is het einde van de cursus!',
    'section.footerEndOfTheCourseText': 'Als je de oefeningen gemaakt hebt, en de peerevaluatie werd afgerond, worden de antwoorden ook nog persoonlijk door ons nagekeken.',
    'section.nextSection': 'Volgend deel',
    'section.nextChapter': 'Volgend hoofdstuk',
    'section.start': 'Begin',
    'section.logisticRegressionExample.slope': 'Helling',
    'section.logisticRegressionExample.intercept': 'Snijpunt',
    'section.footerEndOfTheCourseBAI': 'Vervolg uw reis om uw eerste AI-idee te kunnen implementeren.',
    // quiz peer review
    'quiz.awaitingPeerReview': 'Wachtend op uw beoordeling',
    'quiz.rejectedPeerReview': 'Afgekeurd bij beoordeling',
    'quiz.unsubmittedAnswer': 'Niet ingediend antwoord',
    'quiz.pendingPeerReview': 'In afwachting van beoordeling',
    // quiz
    'quiz.status.answered': 'Beantwoord',
    'quiz.status.rejected': 'Antwoord afgekeurd, probeer het opnieuw.',
    'quiz.status.unanswered': 'Niet beantwoord',
    'quiz.status.exercisesCompleted': 'Afgeronde oefeningen',
    'quiz.status.correctAnswers': 'Juiste antwoorden',
    'quiz.message.rejectedInReview': 'Uw vorige antwoord werd afgekeurd bij de beoordeling. Probeer het opnieuw.',
    'quiz.youAnswered': 'U hebt geantwoord',
    'quiz.yourAnswer': 'Uw antwoord...',
    'quiz.yourScore': 'Uw score:',
    'quiz.quizNotLoaded': 'Kan quiz niet laden',
    'quiz.words': 'Woorden:',
    'quiz.exampleAnswer': 'Voorbeeldantwoord:',
    // peer review
    'peerreview.question1': 'Antwoord is relevant',
    'peerreview.question2': 'Antwoord is uitgebreid',
    'peerreview.question3': 'Antwoord is goed onderbouwd',
    'peerreview.question4': 'Antwoord is gemakkelijk te volgen',
    'peerreview.thankYou': 'Bedankt voor het beoordelen!',
    'peerreview.giveMoreReviews': 'Heeft u nog wat tijd,',
    'peerreview.giveMoreReviewsButton': 'beoordeel dan meer antwoorden.',
    'peerreview.notEnoughAnswers': 'Normaal zou hier een beoordeling staan, maar deze oefening is niet door voldoende mensen beantwoord.',
    'peerreview.selectAnswerMessage': 'Tijd om te beoordelen! Hieronder staan een paar antwoorden van andere gebruikers. Kies en beoordeel er een van. Doe dit ten minste driemaal.',
    'peerreview.minimumPeerReviewWarning': 'De oefening kan alleen worden aanvaard nadat u ten minste drie antwoorden heeft beoordeeld.',
    'peerreview.select': 'Selecteren',
    'peerreview.reportSpam': 'Spam rapporteren',
    'peerreview.feedback': 'Uw antwoord is beoordeeld en aanvaard. Dit denken andere gebruikers ervan:',
    // exercise17
    'quiz.exercise17.xLabel': 'Aantal jaren onderwijs',
    'quiz.exercise17.yLabel': 'Levensverwachting in jaren',
    'quiz.exercise17.textPart1': 'Laten we kijken naar het verband tussen het totale aantal jaren onderwijs (van de kleuterschool tot en met de universiteit) en de levensverwachting. Aan de hand van punten worden hier gegevens uit drie verschillende landen weergegeven:',
    'quiz.exercise17.textPart2': 'We hebben een land waarin mensen gemiddeld 10 jaar onderwijs volgen en een levensverwachting hebben van 57 jaar, één met gemiddeld 13 jaar onderwijs en een levensverwachting van 53 jaar en een derde met gemiddeld 20 jaar onderwijs en een levensverwachting van 80 jaar.',
    'quiz.exercise17.textPart3': 'Versleep de eindpunten van de volle lijn om ervoor te zorgen dat de lijn de datapunten volgt. Je kunt ze niet perfect langs de punten laten lopen, maar dat is niet erg: sommige stippen zullen erboven en andere eronder liggen. Het belangrijkste is dat de lijn de algemene tendens laat zien.',
    'quiz.exercise17.textPart4': 'Nadat je de lijn hebt geplaatst, kun je de levensverwachting voorspellen.',
    'quiz.exercise17.textPart5': 'Wat is op basis van deze data de levensverwachting van mensen die 15 jaar onderwijs hebben genoten? Belangrijk: zelfs als je door het aanpassen van de lijn een specifieke voorspelling verkrijgt die tot op (een deel van) een jaar nauwkeurig is, is het niet per se mogelijk om een overtuigde voorspelling te doen. Houd bij het geven van je antwoord rekening met de beperkte hoeveelheid data.',
    // exercise18
    'quiz.exercise18.xLabel': 'Aantal studiejaren',
    'quiz.exercise18.yLabel': 'Levensverwachting in jaren',
    'quiz.exercise18.textPart1': 'In de vorige oefening beschikten we alleen over de gegevens van drie landen. De volledige gegevensreeks bestaat uit gegevens van 13 verschillende landen, hier weergegeven in een grafiek:',
    'quiz.exercise18.textPart2': 'Zou je op basis van deze data een andere voorspelling doen over de levensverwachting van mensen die 15 jaar onderwijs hebben genoten? Zo ja, waarom?',
    'quiz.exercise18.textPart3': 'Welk van volgende opties past het best bij jouw schatting van de levensverwachting voor mensen met 15 jaar onderwijs? Kies de meest precieze optie die volgens jou gerechtvaardigd is als je de rechte lijn aanpast aan bovenstaande gegevens.',
    // exercise19
    'quiz.exercise19.xLabel': 'Uren gestudeerd',
    'quiz.exercise19.yLabel': 'Slaagkans',
    'quiz.exercise19.textPart1': 'Elke stip in de figuur staat voor een student. Onder de figuur staat de schaal van het aantal uren dat de student voor het examen heeft gestudeerd. De studenten die geslaagd zijn, staan als stippen bovenin de grafiek en de studenten die gezakt zijn staan onderin. We gebruiken de schaal aan de linkerkant om de slaagkans aan te geven, die volgens onderstaande uitleg voortkomt uit het logistisch regressiemodel. Op deze figuur kun je ruwweg zien dat studenten die langer studeerden een grotere slaagkans hadden voor de cursus. Zeker de extreme gevallen zijn intuïtief: het is moeilijk om te slagen als je minder dan een uur studeert, en wie veel tijd aan de leerstof besteedt, zal meestal slagen. Maar hoe zit het met studenten die ergens tussen die extremen in zitten? Wat is bijvoorbeeld je slaagkans na zes uur studeren?',
    'quiz.exercise19.textPart2': 'Met logistische regressie kunnen we de slaagkans kwantificeren. De lijn in de figuur kan worden geïnterpreteerd als die slaagkans: als je bijvoorbeeld vijf uur hebt gestudeerd, bedraagt de slaagkans iets meer dan 20%. We treden niet in detail over het verkrijgen van de lijn, maar dit proces is vergelijkbaar met het leren van gewichten bij lineaire regressie.',
    'quiz.exercise19.textPart3': 'Kijk naar de bovenstaande grafiek. Hoeveel uur zou u ongeveer moeten studeren om voor een universiteitsexamen een slaagkans van 80 % te hebben?',
    'quiz.exercise19.textPart4': ' ',
    // exercise22
    'quiz.exercise22.sigmoidXLabel': 'Input',
    'quiz.exercise22.sigmoidYLabel': 'Output sigmoïdefunctie',
    'quiz.exercise22.stepXLabel': 'Input',
    'quiz.exercise22.stepYLabel': 'Output stapfunctie',
    'quiz.exercise22.identityXLabel': 'Input',
    'quiz.exercise22.identityYLabel': 'Output identiteitsfunctie',
    'quiz.exercise22.textPart1': 'Hieronder staan grafieken voor drie verschillende activatiefuncties met verschillende eigenschappen. Eerst de sigmoïdefunctie, vervolgens de stapfunctie en ten slotte de identiteitsfunctie.',
    // exercise23
    'quiz.exercise23.happyFaces': 'blije gezichten juist ingedeeld',
    'quiz.exercise23.sadFaces': 'trieste gezichten juist ingedeeld',
    // certificate availability
    'certificate.failedToCheck': 'Kan beschikbaarheid certificaat niet controleren',
    'certificate.failedToGenerate': 'Certificaat kan niet worden aangemaakt',
    'certificate.notYetAvailable': 'Na onze officiële bevestiging staat vind je jouw certificaat hier terug. Dit kan even duren. Alvast bedankt voor je geduld!',
    'certificate.updateName': 'Uw certificaat is beschikbaar. Gelieve uw voor- en achternaam bij te werken zodat ze op uw certificaat staan, met behulp van een formulier op uw profielpagina.',
    'certificate.generate': 'Maak uw certificaat hieronder aan.',
    'certificate.generateTextPart1': 'Het certificaat wordt aangemaakt voor',
    'certificate.generateTextPart2': 'Controleer de naam voordat het certificaat wordt aangemaakt, want deze kan achteraf niet worden gewijzigd. U kunt de naam wijzigen met onderstaand formulier.',
    'certificate.generateButton': 'Certificaat aanmaken',
    'certificate.downloadButton': 'Certificaat downloaden',
    'certificate.checkingAvailability': 'Beschikbaarheid certificaat wordt gecontroleerd...',
    // Visualizations
    'visualizations.logisticRegressionChart.classifiedCorrectly': 'Correct ingedeeld',
    'visualizations.logisticRegressionChart.notClassifiedCorrectly': 'Niet correct ingedeeld',
    // section blocks
    'section.block.note': 'Opmerking',
    'section.block.example': 'Voorbeeld',
    'section.block.keyTerminology': 'Belangrijke termen',
    'section.partSummary.spectrumTextPart1': 'Word lid van de ',
    'section.partSummary.spectrum': 'Elements of AI-community',
    'section.partSummary.spectrumTextPart2': ' om dit hoofdstuk te bespreken en vragen te stellen.',
    'section.partSummary.feedbackTitle': 'Geef feedback over dit deel',
    'section.partSummary.feedbackPlaceholder': 'Geef feedback...',
    'section.partSummary.feedbackSuccess': 'Bedankt voor uw feedback!',
    // 404
    'globals.404.title': '404 – Pagina niet gevonden',
    'globals.404.intro': "Deze route bestaat niet... Sorry!",
    'globals.loading': 'Bezig met laden...',
    // footer / menu
    'globals.menu': 'Menu',
    'globals.menu.about': 'Over',
    'globals.menu.faq': 'Veelgestelde vragen',
    'globals.menu.privacyPolicy': 'Privacybeleid',
    'globals.menu.myProfile': 'Mijn profiel',
    'globals.menu.termsofService': 'Servicevoorwaarden',
    // Dashboard/Index
    'dashboard.title': 'Welkom bij de cursus!',
    'dashboard.congratulations.title': 'Gefeliciteerd!',
    'dashboard.congratulations.message': 'U heeft de cursus Elements of AI afgerond',
    'dashboard.congratulations.downloadCertificate': 'Certificaat downloaden',
    'dashboard.notLoggedIn.title': 'Welkom!',
    'dashboard.notLoggedIn.message': 'Registreer of log in voor volledige toegang tot de cursus. Dit is gratis!',
    // Account
    'account.certificate': 'Certificaat',
    'account.myProfile': 'Mijn profiel',
    'account.credits': 'ECTS-studiepunten',
    'account.changePassword': 'Wachtwoord wijzigen',
    'account.changeLanguage': 'Taal wijzigen',
    'account.profileInformation': 'Profiel informatie',
    'account.goToCourse': 'Ga naar de cursus',
    'account.buildingAINew': 'Nieuwe cursus Engels',
    'account.accept': 'Accepteren',
    'account.decline': 'Afwijzen',
    'account.courses': 'Cursussen',
    // Sign Up page
    'signUp.description': 'Vul onderstaand formulier in om een nieuw mooc.fi-account te creëren',
    'signUp.email': 'Uw e-mailadres',
    'signUp.firstName': 'Voornaam',
    'signUp.lastName': 'Achternaam',
    'signUp.postalCode': 'Postcode',
    'signUp.country': 'Waar woont u?',
    'signUp.Password': 'Wachtwoord',
    'signUp.confirmPassword': 'Wachtwoord bevestigen',
    'signUp.howToStudyTitle': 'Hoe wilt u studeren?',
    'signUp.6weeksTitle': 'Cursus van 6 weken',
    'signUp.6weeksSubTitle': 'Aanbevolen (ongeveer 5 uur per week)',
    'signUp.6weeksText': 'Een deadline is een beproefde manier om u te helpen de cursus te voltooien.',
    'signUp.selfPacedTitle': 'Eigen tempo',
    'signUp.selfPacedText': 'U kunt de cursus in uw eigen tempo volgen.',
    'signUp.ectsTitle': 'Vraagt u ECTS-studiepunten aan?',
    'signUp.ectsTitleSwe': '',
    'signUp.ectsStudent': 'Ik ben student aan de universiteit van Helsinki. Indien u dit vakje aanvinkt en uw studentnummer invult, krijgt u de ECTS-studiepunten automatisch.',
    'signUp.ectsStudentSwe': '',
    'signup.ectsStudentSweLink': '',
    'signUp.ectsOpenUni': 'Vink dit vakje aan om per e-mail instructies te ontvangen over het aanvragen van ECTS-studiepunten',
    'signUp.studentNumber': 'Studentnummer van de universiteit van Helsinki (als u student bent)',
    'signUp.privacyOptIn': 'Ik geef toestemming om verzamelde gegevens over mijn studiegedrag te gebruiken voor onderzoeksdoeleinden. Deze gegevens bevatten informatie over het gebruik van materialen en de oefeningen van de cursus. Uit publicaties kan de identiteit van personen niet worden afgeleid.',
    'signUp.marketingOptIn': 'Ik ga akkoord met het ontvangen van updates over nieuwe taalversies en informatie over nieuwe cursussen. Ik ga ermee akkoord mijn contactgegevens te delen om op maat gemaakte berichten op platforms van derden te ontvangen. Lees meer in ons privacybeleid.',
    'signUp.privacyLink': 'Lees ons privacybeleid.',
    'signUp.error': 'Er staan fouten in uw formulier. Controleer uw formulier.',
    'signUp.acceptPolicyFirst': 'Ik accepteer het privacybeleid en de servicevoorwaarden.',
    // Sign in page
    'signIn.title': 'Aanmelden',
    'signIn.intro': 'Gebruik onderstaand formulier om u met uw mooc.fi-account aan te melden.',
    'signIn.email': 'Uw e-mailadres',
    'signIn.password': 'Uw wachtwoord',
    'signIn.noAccount': "Hebt u geen account?",
    'signIn.signUpNow': 'Nu registreren',
    // Forgot password
    'pwForget.title': 'Wachtwoord vergeten',
    'pwForget.description': 'Vul het e-mailadres van uw mooc.fi-account in en we sturen u een link waarmee u uw wachtwoord opnieuw kunt instellen.',
    'pwForget.sendResetLink': 'Link verzenden voor het opnieuw instellen van het wachtwoord',
    'pwForget.completedDescription': 'U ontvangt binnenkort een e-mail van mooc.fi met een link waarmee u uw wachtwoord opnieuw kunt instellen. Als u het bericht niet ziet, controleer dan uw spamfilter.',
    'pwForget.problemDescription': 'Als u problemen tegenkomt, neem dan contact op met mooc@cs.helsinki.fi.',
    'pwForget.resetEmailSent': 'Er is een e-mailbericht over het opnieuw instellen van het wachtwoord verzonden',
    'pwForget.emailPlaceholder': 'E-mailadres',
    // password change
    'pwChange.authError': 'Authenticatie mislukt. Probeer het opnieuw',
    'pwChange.unexpError': 'Wachtwoord niet bijgewerkt door onverwachte fouten',
    'pwChange.required': 'Verplicht',
    'pwChange.pwMustMatch': 'De wachtwoorden moeten overeenkomen',
    'pwChange.currentPassword': 'Huidig wachtwoord',
    'pwChange.newPassword': 'Nieuw wachtwoord',
    'pwChange.confirmPassword': 'Bevestig nieuw wachtwoord',
    'pwChange.changingPassword': 'Wachtwoord wijzigen...',
    'pwChange.changePassword': 'Wachtwoord wijzigen',
    'pwChange.passwordChanged': 'Wachtwoord gewijzigd',
    // user details
    'userDetails.authError': 'Authenticatie mislukt. Probeer het opnieuw',
    'userDetails.unexpError': 'Profiel niet bijgewerkt door onverwachte fouten',
    'userDetails.required': 'Verplicht',
    'userDetails.invalidEmail': 'Ongeldig e-mailadres',
    'userDetails.email': 'E-mail',
    'userDetails.emailAddress': 'E-mailadres',
    'userDetails.firstName': 'Voornaam',
    'userDetails.lastName': 'Achternaam',
    'userDetails.language': 'Taal',
    'userDetails.updatingProfile': 'Profiel bijwerken...',
    'userDetails.updateProfile': 'Profiel bijwerken',
    'userDetails.profileUpdated': 'Profiel bijgewerkt',
    // languages
    'languages.en.long': 'Engels',
    'languages.fi.long': 'Fins',
    'languages.se.long': 'Zweeds',
    'languages.de.long': 'Duits (Duitsland)',
    'languages.ee.long': 'Ests',
    'languages.nl.long': 'Nederlands (Nederland)',
    'languages.no.long': 'Noors',
    'languages.lv.long': 'Lets',
    'languages.lt.long': 'Litouws',
    'languages.nl-be.long': 'Nederlands (België)',
    'languages.fr.long': 'Frans (Frankrijk)',
    'languages.fr-be.long': 'Frans (België)',
    'languages.it.long': 'Italiaans',
    'languages.mt.long': 'Maltees',
    'languages.ga.long': 'Iers',
    'languages.hr.long': 'Kroatisch',
    'languages.pl.long': 'Pools',
    'languages.sk.long': 'Slowaaks',
    'languages.en-ie.long': 'Engels (Ierland)',
    'languages.da.long': 'Deens',
    'languages.ro.long': 'Roemeens',
    'languages.is.long': 'IJslands',
    'languages.de-at.long': 'Duits (Oostenrijk)',
    'languages.en-lu.long': 'Engels (Luxemburg)',
    'languages.bg.long': 'Bulgaars',
    'languages.cs.long': 'Tsjechisch',
    'languages.sl.long': 'Sloveens',
    'languages.pt.long': 'Portugees',
    'languages.es.long': 'Spaans',
    'languages.el.long': 'Grieks',
    // Email verfification
    'emailVerification.completedMessage': 'Uw e-mailadres is geverifieerd',
    'emailVerification.verified': 'Geverifieerd',
    // Exercises
    'exercise.loading': 'Oefening laden...',
    'exercise.signUp': 'Registreer om oefeningen te maken:',
    'exercise.score': 'Uw score:',
    'exercise.wrongLocale': 'Verkeerde landinstellingen',
    // Part tempplate
    'partTemplate.intro1': 'In hoofdstuk ',
    'partTemplate.intro2': ' behandelen we de volgende delen. Klik hieronder om te beginnen:',
    'partTemplate.spectrumPart1': 'Word lid van de ',
    'partTemplate.spectrum': 'Elements of AI-community',
    'partTemplate.spectrumPart2': ' om dit hoofdstuk te bespreken en vragen te stellen.',
    // missing info
    'missingInfo.title': 'Ontbrekende informatie',
    'missingInfo.body': 'Normaal worden deze vragen gesteld bij registratie, maar u bent ingelogd met een bestaand mooc.fi-account. Vul onderstaand formulier in om door te gaan.',
    'missingInfo.privacyPolicy': 'Lees ons privacybeleid.',
    'missingInfo.error': 'Er staan fouten in uw formulier. Controleer uw formulier.',
    'missingInfo.privacyPolicyUpdateBody': "We've updated our privacy policy. Here is a summary of the changes. We advertise our courses to potential new students by forming audiences in marketing platforms. This may involve sharing email addresses with these platforms. For the same purpose, anonymised activity data will be shared with marketing networks. You can prevent the sharing of email information by unchecking the marketing consent checkbox in your course profile. To prevent the sharing of activity data, you can change the cookie settings on the course site. Accepting these terms is required to continue using the service.",
    'missingInfo.privacyPolicyUpdateLink': 'Lees ons privacybeleid hier.',
    // routes
    'routes.LANDING': '/nl-be/',
    'routes.SIGN_UP': '/nl-be/signup',
    'routes.SIGN_IN': '/nl-be/signin',
    'routes.MISSING_INFO': '/nl-be/missinginfo',
    'routes.PASSWORD_FORGET': '/nl-be/pw-forget',
    'routes.HOME': '/nl-be/home',
    'routes.ACCOUNT': '/nl-be/account',
    'routes.PRIVACY': 'https://www.elementsofai.be/faq/privacybeleid',
    'routes.FAQ': 'https://www.elementsofai.be/faq',
    'routes.ABOUT': 'https://www.elementsofai.be',
    'routes.SPECTRUM': 'https://community.elementsofai.com/c/nl-nederlands',
    'routes.ects': 'https://mooc.fi/en/register-completion/elements-of-ai',
    'routes.TERMS': 'https://www.elementsofai.com/terms-of-service',
    'routes.BUILDING_AI': 'https://buildingai.elementsofai.com',
    'routes.ects.faq': 'https://www.elementsofai.com/faq/how-can-i-get-2-ects-credits',
    'routes.ACCEPT_POLICY': '/nl-be/accept-policy',

    // MarkdownComponents
    'markdowncomponents.linearRegressionStatic.xLabel': 'Kopjes koffie per dag',
    'markdowncomponents.linearRegressionStatic.yLabel': 'Geschreven regels code',
    // meta
    'meta.title': 'Een gratis onlinecursus',
    'meta.titleTemplate': '%s - Elements of AI',
    'meta.description': 'Leer meer over de Universiteit van Helsinki en de AI-cursus van Reaktor voor studenten en werkenden - geen kennis van programmeren of wiskunde vereist',
    'meta.sitename': 'Elements of AI',
    'meta.title.og': 'A free online introduction to artificial intelligence for non-experts',
    // ECTS
    'ects.text': 'Na afloop van de cursus krijgt u instructies voor het aanvragen van ECTS-studiepunten.',
    'ects.textCompleted': 'Als u een Fins socialezekerheidsnummer hebt en punten wilt aanvragen, klik dan',
    'ects.link': 'hier.',
    'ects.info': 'Would you like to apply for ECTS credits?',
    'ects.readMore': 'Read more',
    // Countries
    'countryselect.select': "Selecteer alstublieft",
    'Finland': "Finland",
    'Estonia': "Estland",
    'Germany': "Duitsland",
    'Sweden': "Zweden",
    "Norway": "Noorwegen",
    "Latvia": "Letland",
    "Netherlands": "Nederland",
    "Countries": {
        "Afganistan": "Afganistan",
        "Åland Islands": "Aland-eilanden",
        "Albania": "Albanië",
        "Algeria": "Algerije",
        "American Samoa": "Amerikaans Samoa",
        "Andorra": "Andorra",
        "Angola": "Angola",
        "Anguilla": "Anguilla",
        "Antarctica": "Antarctica",
        "Antigua and Barbuda": "Antigua en Barbuda",
        "Argentina": "Argentinië",
        "Armenia": "Armenië",
        "Aruba": "Aruba",
        "Australia": "Australië",
        "Austria": "Oostenrijk",
        "Azerbaijan": "Azerbeidzjan",
        "Bahamas": "Bahamas",
        "Bahrain": "Bahrein",
        "Bangladesh": "Bangladesh",
        "Barbados": "Barbados",
        "Belarus": "Wit-Rusland",
        "Belgium": "België",
        "Belize": "Belize",
        "Benin": "Benin",
        "Bermuda": "Bermuda",
        "Bhutan": "Bhutan",
        "Bolivia": "Bolivia",
        "Bosnia and Herzegovina": "Bosnië-Herzegovina",
        "Botswana": "Botswana",
        "Bouvet Island": "Bouvet Island",
        "Brazil": "Brazilië",
        "British Indian Ocean Territory": "Brits-Indisch oceaan gebied",
        "Brunei Darussalam": "Brunei Darussalam",
        "Bulgaria": "Bulgarije",
        "Burkina Faso": "Burkina Faso",
        "Burundi": "Burundi",
        "Cambodia": "Cambodja",
        "Cameroon": "Kameroen",
        "Canada": "Canada",
        "Cape Verde": "Kaapverdië",
        "Cayman Islands": "Kaaiman Eilanden",
        "Central African Republic": "Centraal Afrikaanse Republiek",
        "Chad": "Tsjaad",
        "Chile": "Chili",
        "China": "China",
        "Christmas Island": "Kersteiland",
        "Cocos (Keeling) Islands": "Cocos (Keeling) eilanden",
        "Colombia": "Colombia",
        "Comoros": "Comoren",
        "Congo": "Congo",
        "Congo, The Democratic Republic of The": "Congo, de Democratische Republiek",
        "Cook Islands": "Cookeilanden",
        "Costa Rica": "Costa Rica",
        "Cote D'ivoire": "Ivoorkust",
        "Croatia": "Kroatië",
        "Cuba": "Cuba",
        "Cyprus": "Cyprus",
        "Czechia": "Tsjechië",
        "Denmark": "Denemarken",
        "Djibouti": "Djibouti",
        "Dominica": "Dominica",
        "Dominican Republic": "Dominicaanse Republiek",
        "Ecuador": "Ecuador",
        "Egypt": "Egypte",
        "El Salvador": "El Salvador",
        "Equatorial Guinea": "Equatoriaal-Guinea",
        "Eritrea": "Eritrea",
        "Estonia": "Estland",
        "Eswatini": "Eswatini",
        "Ethiopia": "Ethiopië",
        "Falkland Islands (Malvinas)": "Falklandeilanden (Malvinas)",
        "Faroe Islands": "Faeröer",
        "Fiji": "Fiji",
        "Finland": "Finland",
        "France": "Frankrijk",
        "French Guiana": "Frans-Guyana",
        "French Polynesia": "Frans-Polynesië",
        "French Southern Territories": "Franse zuidelijke gebieden",
        "Gabon": "Gabon",
        "Gambia": "Gambia",
        "Georgia": "Georgië",
        "Germany": "Duitsland",
        "Ghana": "Ghana",
        "Gibraltar": "Gibraltar",
        "Greece": "Griekenland",
        "Greenland": "Groenland",
        "Grenada": "Grenada",
        "Guadeloupe": "Guadeloupe",
        "Guam": "Guam",
        "Guatemala": "Guatemala",
        "Guernsey": "Guernsey",
        "Guinea": "Guinea",
        "Guinea-Bissau": "Guinee-Bissau",
        "Guyana": "Guyana",
        "Haiti": "Haïti",
        "Heard Island and Mcdonald Islands": "Heard Island en Mcdonald Islands",
        "Holy See (Vatican City State)": "Heilige Stoel (Vaticaanstad)",
        "Honduras": "Honduras",
        "Hong Kong": "Hong Kong",
        "Hungary": "Hongarije",
        "Iceland": "IJsland",
        "India": "India",
        "Indonesia": "Indonesië",
        "Iran, Islamic Republic of": "Iran, Islamitische Republiek",
        "Iraq": "Irak",
        "Ireland": "Ierland",
        "Isle of Man": "Isle of Man",
        "Israel": "Israël",
        "Italy": "Italië",
        "Jamaica": "Jamaica",
        "Japan": "Japan",
        "Jersey": "Jersey",
        "Jordan": "Jordanië",
        "Kazakhstan": "Kazachstan",
        "Kenya": "Kenia",
        "Kiribati": "Kiribati",
        "Korea, Democratic People's Republic of": "Korea, Democratische Volksrepubliek",
        "Korea, Republic of": "Korea, republiek van",
        "Kosovo": "Kosovo",
        "Kuwait": "Koeweit",
        "Kyrgyzstan": "Kirgizië",
        "Lao People's Democratic Republic": "Lao Democratische Volksrepubliek",
        "Latvia": "Letland",
        "Lebanon": "Libanon",
        "Lesotho": "Lesotho",
        "Liberia": "Liberia",
        "Libya": "Libië",
        "Liechtenstein": "Liechtenstein",
        "Lithuania": "Litouwen",
        "Luxembourg": "Luxemburg",
        "Macao": "Macao",
        "Madagascar": "Madagascar",
        "Malawi": "Malawi",
        "Malaysia": "Maleisië",
        "Maldives": "Maldiven",
        "Mali": "Mali",
        "Malta": "Malta",
        "Marshall Islands": "Marshall eilanden",
        "Martinique": "Martinique",
        "Mauritania": "Mauritanië",
        "Mauritius": "Mauritius",
        "Mayotte": "Mayotte",
        "Mexico": "Mexico",
        "Micronesia, Federated States of": "Micronesië, Federale Staten van",
        "Moldova, Republic of": "Moldavië, Republiek",
        "Monaco": "Monaco",
        "Mongolia": "Mongolië",
        "Montenegro": "Montenegro",
        "Montserrat": "Montserrat",
        "Marocco": "Marokko",
        "Mozambique": "Mozambique",
        "Myanmar": "Myanmar",
        "Namibia": "Namibië",
        "Nauru": "Nauru",
        "Nepal": "Nepal",
        "Netherlands": "Nederland",
        "Netherlands Antilles": "Nederlandse Antillen",
        "New Caledonia": "Nieuw-Caledonië",
        "New Zealand": "Nieuw-Zeeland",
        "Nicaragua": "Nicaragua",
        "Niger": "Niger",
        "Nigeria": "Nigeria",
        "Niue": "Niue",
        "Norfolk Island": "Norfolkeiland",
        "North Macedonia": "Noord-Macedonië",
        "Northern Mariana Islands": "noordelijke Mariana eilanden",
        "Norway": "Noorwegen",
        "Oman": "Oman",
        "Pakistan": "Pakistan",
        "Palau": "Palau",
        "Palestinian Territory, Occupied": "Bezet Palestijns gebied",
        "Panama": "Panama",
        "Papua New Guinea": "Papoea-Nieuw-Guinea",
        "Paraguay": "Paraguay",
        "Peru": "Peru",
        "Philippines": "Filippijnen",
        "Pitcairn": "Pitcairn",
        "Poland": "Polen",
        "Portugal": "Portugal",
        "Puerto Rico": "Puerto Rico",
        "Qatar": "Qatar",
        "Reunion": "Réunion",
        "Romania": "Roemenië",
        "Russian Federation": "Russische Federatie",
        "Rwanda": "Rwanda",
        "Saint Helena": "Sint-Helena",
        "Saint Kitts and Nevis": "Saint Kitts en Nevis",
        "Saint Lucia": "Saint Lucia",
        "Saint Pierre and Miquelon": "Saint Pierre en Miquelon",
        "Saint Vincent and The Grenadines": "Saint Vincent en de Grenadines",
        "Samoa": "Samoa",
        "San Marino": "San Marino",
        "Sao Tome and Principe": "Sao Tome en Principe",
        "Saudi Arabia": "Saoedi-Arabië",
        "Senegal": "Senegal",
        "Serbia": "Servië",
        "Seychelles": "Seychellen",
        "Sierra Leone": "Sierra Leone",
        "Singapore": "Singapore",
        "Slovakia": "Slowakije",
        "Slovenia": "Slovenië",
        "Solomon Islands": "Solomon eilanden",
        "Somalia": "Somalië",
        "South Africa": "Zuid-Afrika",
        "South Georgia and The South Sandwich Islands": "Zuid-Georgië en de Zuidelijke Sandwicheilanden",
        "South Sudan": "Zuid-Soedan",
        "Spain": "Spanje",
        "Sri Lanka": "Sri Lanka",
        "Sudan": "Soedan",
        "Suriname": "Suriname",
        "Svalbard and Jan Mayen": "Svalbard en Jan Mayen",
        "Sweden": "Zweden",
        "Swizerland": "Zwitserland",
        "Syrian Arab Republic": "Syrische Arabische Republiek",
        "Taiwan": "Taiwan",
        "Tajikistan": "Tadzjikistan",
        "Tanzania, United Republic of": "Tanzania, Verenigde Republiek",
        "Thailand": "Thailand",
        "Timor-leste": "Oost-Timor",
        "Togo": "Gaan",
        "Tokelau": "Tokelau",
        "Tonga": "Tonga",
        "Trinidad and Tobago": "Trinidad en Tobago",
        "Tunisia": "Tunesië",
        "Türkiye": "Turkije",
        "Turkmenistan": "Turkmenistan",
        "Turks and Caicos Islands": "Turks- en Caicoseilanden",
        "Tuvalu": "Tuvalu",
        "Uganda": "Oeganda",
        "Ukraine": "Oekraïne",
        "United Arab Emirates": "Verenigde Arabische Emiraten",
        "United Kingdom": "Verenigd Koningkrijk",
        "United States": "Verenigde Staten",
        "United States Minor Outlying Islands": "Kleine afgelegen eilanden van de Verenigde Staten",
        "Uruguay": "Uruguay",
        "Uzbekistan": "Oezbekistan",
        "Vanuatu": "Vanuatu",
        "Venezuela": "Venezuela",
        "Viet Nam": "Vietnam",
        "Virgin Islands, British": "Britse Maagdeneilanden",
        "Virgin Islands, U.S.": "Amerikaanse Maagdeneilanden",
        "Wallis and Futuna": "Wallis en Futuna",
        "Western Sahara": "Westelijke Sahara",
        "Yemen": "Jemen",
        "Zambia": "Zambia",
        "Zimbabwe": "Zimbabwe"
    },

    //Alt texts
    'alt.example-1': 'twee zelfrijdende auto’s',
    'alt.example-2': 'hand met een mobieltje',
    'alt.example-3': 'gezicht van een vrouw',
    'alt.defining-ai': 'woorden die met AI te maken hebben',
    'alt.turing-test': 'man die via de computer met een robot en een vrouw chat',
    'alt.chinese-room': 'het Chinese kamerexperiment',
    'alt.chicken-crossing': 'robot in een boot die naar een kip, een vos en een zak kippenvoer kijkt',
    'alt.a-to-b': 'hand met een mobieltje met een navigatieapp',
    'alt.tic-tac-toe': 'twee kinderen die boter-kaas-en-eieren spelen',
    'alt.self-driving-car': 'zelfrijdende auto',
    'alt.spam-or-ham': 'normale e-mail en spam',
    'alt.mnist': 'MNIST-dataset',
    'alt.nearest-neighbor': 'twee winkelende mensen',
    'alt.nearest-neighbor-graph': 'de naaste-buurclassificatie',
    'alt.recommendation': 'een man en vrouw die via hun telefoon naar muziek luisteren',
    'alt.price-real-estate': 'drie verschillende huizen',
    'alt.supervised-learning': 'mens die een robot lesgeeft',
    'alt.dice': 'dobbelsteen',
    'alt.chess': 'schaakbord',
    'alt.poker': 'hand met speelkaarten',
    'alt.eyes': 'drie personen met bruine ogen en één met blauwe ogen',
    'alt.search-1': 'enkele weg die naar een doel leidt',
    'alt.search-2': 'vier verschillende wegen die naar hetzelfde doel leiden',
    'alt.chicken-crossing-1': 'roeibootpuzzel begintoestand',
    'alt.chicken-crossing-2': 'roeibootpuzzel eerste overgang',
    'alt.chicken-crossing-3': 'roeibootpuzzel alle overgangen',
    'alt.chicken-crossing-4': 'roeibootpuzzel met de beste manier',
    'alt.chicken-crossing-5': 'roeibootpuzzel begintoestand	',
    'alt.implication-1': 'een man en een vrouw',
    'alt.implication-2': 'ogen',
    'alt.implication-3': 'toezichtcamera',
    'alt.implication-4': 'robot die op een laptop werkt',
    'alt.oddchange': 'zon en wolken',
    'alt.brain': 'tekening van hersenen',
    'alt.carstop': 'zelfrijdende auto',
    'alt.gan': 'robot met een plaatje van een kat en van een stopbord in de hand',
    'alt.hammock': 'robot die man in hangmat koelte toewaait',
    'alt.game-tree-1': 'spelverloop 1',
    'alt.game-tree-2': 'spelverloop 2',
    'alt.game-tree-3': 'spelverloop 3',
    'alt.game-tree-4': 'spelverloop 4',
    'alt.bayes-rule-1': 'beeld van valse positieven en negatieven van een kankeronderzoek',
    'alt.bayes-rule-2': 'beeld van valse positieven en negatieven van een kankeronderzoek',
    'alt.defineai': 'woorden die met AI te maken hebben',
    'alt.winter': 'robot die in de sneeuw slaapt',
    'alt.terminator': 'enge robot',
}
